<template>
  <v-card class="pa-6">
    <div class="mb-1"><b>{{ $t('APPEARANCE.THEME') }}</b></div>
    <btn-toggle-filter v-model="darkMode" mandatory="force" variant="outlined" density="compact">
      <v-btn :value="false">
        <v-icon start>far fa-sun</v-icon>{{ $t('APPEARANCE.THEME_LIGHT') }}
      </v-btn>
      <v-btn :value="true">
        <v-icon start>far fa-moon</v-icon>{{ $t('APPEARANCE.THEME_DARK') }}
      </v-btn>
    </btn-toggle-filter>

    <div class="mt-6 mb-1"><b>{{ $t('APPEARANCE.BACKGROUND') }}</b></div>
    <div class="d-flex flex-wrap gap-4">
      <v-btn style="height: 65px; width: 116px" @click="selectBg('')">
        <v-icon>far fa-trash-alt</v-icon>
      </v-btn>
      <v-btn v-for="(bg, key) in customBgList" :class="{ 'elevation-8': selectedBg == key }" :key="key" style="height: 65px; width: 116px" @click="selectBg(key)">
        <v-img :src="bg" class="rounded" cover position="top" :title="key" style="position: absolute; inset: 0"></v-img>
      </v-btn>
    </div>
  </v-card>
</template>

<style lang="scss">
  @use './custom-bg.scss';
</style>

<script>
  import { mapState, mapActions } from 'pinia';
  import useUserOptionsStore from '@/stores/user-options';
  import darkModeMixin from '@/components/Manage/ManageProfile/darkModeMixin';
  import customBgList from './customBgList';

  export default {
    mixins: [darkModeMixin],
    data() {
      return {
        customBgList,
      };
    },
    computed: {
      selectedBg() { return this.userOptions['appearance-theme-bg']; },
      ...mapState(useUserOptionsStore, ['userOptions']),
    },
    created() {
      this.loadUserOptions({ filter: 'appearance' });
    },
    methods: {
      async selectBg(newVal) {
        this.userOptions['appearance-theme-bg'] = newVal;
        document.body.classList.forEach((className) => {
          if (className.startsWith('custom-bg-')) document.body.classList.remove(className);
        });
        if (newVal) document.body.classList.add(`custom-bg-${newVal}`);
        this.saveUserOption({ key: 'appearance-theme-bg', value: newVal });
      },
      ...mapActions(useUserOptionsStore, ['loadUserOptions', 'saveUserOption']),
    },
  };
</script>
